import SimpleBar from 'simplebar'

export default function () {
  const scrollContainers = document.querySelectorAll('.js-custom-scrollbar')

  // Initialiser SimpleBar pour chacun des conteneurs
  scrollContainers.forEach((container) => {
    new SimpleBar(container, { autoHide: false }) // Assurez-vous que SimpleBar n'interfère pas
    makeHorizontalDraggable(container)
  })
}

// Fonction pour rendre un conteneur draggable horizontalement
function makeHorizontalDraggable(container) {
  const simplebarContentWrapper = container.querySelector(
    '.simplebar-content-wrapper',
  )
  let isDragging = false
  let startX
  let scrollLeft

  // Changer le curseur lorsque la souris est au-dessus du conteneur
  container.style.cursor = 'grab'

  simplebarContentWrapper.addEventListener('mousedown', (e) => {
    isDragging = true
    startX = e.pageX - simplebarContentWrapper.offsetLeft
    scrollLeft = simplebarContentWrapper.scrollLeft
    container.style.cursor = 'grabbing' // Changer le curseur pour indiquer le drag
    e.preventDefault() // Prévenir le comportement par défaut
  })

  simplebarContentWrapper.addEventListener('mouseup', () => {
    isDragging = false
    container.style.cursor = 'grab' // Revenir au curseur initial
  })

  simplebarContentWrapper.addEventListener('mousemove', (e) => {
    if (!isDragging) return
    e.preventDefault() // Prévenir le comportement par défaut
    const x = e.pageX - simplebarContentWrapper.offsetLeft
    const walk = (x - startX) * 2 // Ajuster la vitesse de défilement horizontal
    simplebarContentWrapper.scrollLeft = scrollLeft - walk
  })

  // Assurez-vous que le drag est désactivé lorsque la souris quitte le conteneur
  simplebarContentWrapper.addEventListener('mouseleave', () => {
    if (isDragging) {
      isDragging = false
      container.style.cursor = 'grab' // Revenir au curseur initial
    }
  })
}
